import cf from '@/config'
import fc from '@/util/interface'
import st from '@/util/cookies'
import ls from '@/util/localStorage'

const prefix  = cf.prefix;
const api     = fc.biz4;
const expire  = {expires : 1, secure:false};

export default {        
    
    login(user, pass, capt) {
        return api.post('/user/admin-login', {
            username: user,
            password: pass,
            captcha : capt
        })
    },
    
    signup(formdata) {
        return api.post('/user/signup', formdata, null, {
          'accept': 'application/json',
          'Accept-Language': 'en-US,en;q=0.8',
          'Content-Type': `multipart/form-data; boundary=${formdata._boundary}`,
        });
    },
    
    captcha(){
        return api.post('/user/captcha');
    },
    
    set(data) { 
        this.unset();        
        st.set(prefix+'cid' , data.cid, expire);
        st.set(prefix+'key' , data.token, expire);
        st.set(prefix+'user' , data.user, expire);
        st.set(prefix+'regdate', Number(new Date()), expire);
        st.set(prefix+'granted', "true" + data.token, expire);        
        ls.set(prefix+'avatar', data.avatar);
        window.location = window.location.origin + window.location.pathname;
        return true;
    },
    
    unset() {        
        st.remove(prefix+'cid');
        st.remove(prefix+'key');
        st.remove(prefix+'user');
        st.remove(prefix+'regdate');
        st.remove(prefix+'granted');
        ls.remove(prefix+'avatar');
        return true;
    },
    
    isLogin(){
        var reg = this.info();
        if(reg.granted == "true" + reg.token){                                      
            return true;
        } 
        window.getApp.$emit('APP_LOGOUT');  
        return false;
    },
    
    info() {
        return {
            cid     : st.get(prefix+'cid'),
            token   : st.get(prefix+'key'),
            attr    : JSON.parse(st.get(prefix+'user')),
            regdate : st.get(prefix+'regdate'),
            granted : st.get(prefix+'granted'),
            avatar  : ls.get(prefix+'avatar')
        }
    },
    
    roles(){
      let user  = this.info().attr;
      let roles = user ? user.roles : [];
      return roles;
    },
    
    inArray(needle, haystack = []) {
        var length = haystack.length;
        for(var i = 0; i < length; i++) {
            if(typeof haystack[i] == 'object') {
                if(arrayCompare(haystack[i], needle)) return true;
            } else {
                if(haystack[i] == needle) return true;
            }
        }
        return false;
    }
    //commit this
}
